import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import request from '../../../helpers/request';
import { createInfoBindKey } from '../queries/useInfoBinds';
import { selectedInfoSelector } from '../store/selectors';

const deleteInfoBind = async (bindId) => {
  const data = await request.delete(
    `/Information/bind/${bindId}`,
    {},
    'Не удалось удалить привязку',
    'Error'
  );

  return data;
};

const deleteInfoBinds = async (bindIds) => {
  const data = await request.post(
    '/Information/bind/delete',
    { ids: bindIds },
    'Не удалось удалить привязки',
    'Error'
  );

  return data;
};

const useDeleteInfoBind = () => {
  const info = useSelector(selectedInfoSelector);
  const queryClient = useQueryClient();

  const deleteBindMutation = useMutation(
    ({ bindId }) => deleteInfoBind(bindId),
    {
      onSuccess: (data, { bindId }) => {
        if (data?.result === 'Ok' && info) {
          queryClient.setQueryData(createInfoBindKey(info.id), (oldData) =>
            oldData?.filter((oldBind) => oldBind.id !== bindId)
          );
        }
      },
    }
  );

  const deleteBindsMutation = useMutation(
    ({ bindIds }) => deleteInfoBinds(bindIds),
    {
      onSuccess: (data, { bindIds }) => {
        if (data?.result === 'Ok' && info) {
          const removedIds = new Set(bindIds);

          queryClient.setQueryData(createInfoBindKey(info.id), (oldData) =>
            oldData?.filter((oldBind) => !removedIds.has(oldBind.id))
          );
        }
      },
    }
  );

  const deleteMutate = (bindId) => deleteBindMutation.mutate({ bindId });
  const deleteMutateAsync = (bindId) =>
    deleteBindMutation.mutateAsync({ bindId });
  const deleteBindsAsync = (bindIds) =>
    deleteBindsMutation.mutateAsync({ bindIds });

  return {
    deleteBind: deleteMutate,
    deleteBindAsync: deleteMutateAsync,
    deleteBindsAsync,
    loading: deleteBindMutation.isLoading || deleteBindsMutation.isLoading,
  };
};

export default useDeleteInfoBind;
